export type SanitizePathParamOptions = {
  maxLength?: number;
  asciiOnly?: boolean;
};

const CONTROL_CHARS = /[\u0000-\u001F\u007F]/g;
const ASCII_SAFE = /^[A-Za-z0-9._~-]+$/;

export function sanitizePathParam(input: unknown, options?: SanitizePathParamOptions): string {
  const { maxLength = 256, asciiOnly = true } = options || {};
  let value = String(input ?? '').trim();
  value = value.normalize ? value.normalize('NFKC') : value;
  value = value.replace(CONTROL_CHARS, '');
  if (!value) throw new Error('Invalid path parameter');
  if (value === '.' || value === '..') throw new Error('Invalid path parameter');
  if (value.includes('/') || value.includes('\\')) throw new Error('Invalid path parameter');
  let out: string;
  if (asciiOnly) {
    if (!ASCII_SAFE.test(value)) {
      out = encodeURIComponent(value);
    } else {
      out = value;
    }
  } else {
    out = encodeURIComponent(value);
  }
  if (!out || out.length > maxLength) throw new Error('Invalid path parameter');
  return out;
}

